import { useState, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import EdSwitch from '@/components/forms/EdSwitch'
import EdSelect from '@/components/forms/EdSelect'
import EdTextfield from '@/components/forms/EdTextfield'

interface MixedDiscentiSectionProps {
  isReadOnly?: boolean;
}

const MixedDiscentiSection = ({ isReadOnly = false }: MixedDiscentiSectionProps) => {
  const { register, watch, setValue } = useFormContext();

  const selected = watch('discente');
  const selections = watch('discentiSelezionati') || {};

  // Stati per il form di aggiunta campo
  const [tipologia, setTipologia] = useState('');
  const [nomeEtichetta, setNomeEtichetta] = useState('');
  const [descrizione, setDescrizione] = useState('');
  
  // Stati per le voci del menu a tendina
  const [vociTendina, setVociTendina] = useState(['']);

  const items = [
    { id: '1', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '2', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '3', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '4', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '5', name: 'Carlo Trainao', role: 'Tutor di processo' },
  ];

  // Opzioni per la dropdown tipologia
  const tipologiaOptions = [
    { value: 'testo', label: 'Testo' },
    { value: 'menu', label: 'Menu a tendina' },
    { value: 'data', label: 'Data' },
    { value: 'checkbox', label: 'Checkbox' },
    { value: 'file', label: 'Carica file' },
  ];

  // Funzioni per gestire il form di aggiunta campo
  const handleConferma = () => {
    // Qui implementeresti la logica per aggiungere il nuovo campo
    console.log('Nuovo campo:', { 
      tipologia, 
      nomeEtichetta, 
      descrizione,
      vociTendina: tipologia === 'menu' ? vociTendina : undefined
    });
    
    // Reset dei campi
    setTipologia('');
    setNomeEtichetta('');
    setDescrizione('');
    setVociTendina(['']);
  };

  const handleAnnulla = () => {
    // Reset dei campi
    setTipologia('');
    setNomeEtichetta('');
    setDescrizione('');
    setVociTendina(['']);
  };

  // Handlers per i componenti personalizzati
  const handleTipologiaChange = (e: any) => {
    setTipologia(e.target.value);
  };

  const handleNomeEtichettaChange = (e: any) => {
    setNomeEtichetta(e.target.value);
  };

  const handleDescrizioneChange = (e: any) => {
    setDescrizione(e.target.value);
  };

  // Funzioni per gestire le voci del menu a tendina
  const handleAggiungiVoce = () => {
    setVociTendina([...vociTendina, '']);
  };

  const handleRimuoviVoce = (index: number) => {
    const newVoci = vociTendina.filter((_, i) => i !== index);
    // Assicurati che ci sia sempre almeno un campo vuoto
    if (newVoci.length === 0) {
      setVociTendina(['']);
    } else {
      setVociTendina(newVoci);
    }
  };

  const handleVoceChange = (index: number, value: string) => {
    const newVoci = [...vociTendina];
    newVoci[index] = value;
    setVociTendina(newVoci);
  };

  // Imposta il valore di default per il tipo di selezione
  useEffect(() => {
    if (!selected) {
      setValue('discente', 'campi_categoria', { shouldDirty: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <span className="text-[20px] text-[#4F4F4F] font-bold">Dati discenti al corso</span>

      {/* Radio buttons per tipo selezione */}
      <div className="flex gap-6">
        <label className={`flex items-center gap-2 ${isReadOnly ? 'cursor-not-allowed ' : 'cursor-pointer'}`}>
          <input
            type="radio"
            value="campi_categoria"
            {...register('discente')}
            disabled={isReadOnly}
            className={`w-4 h-4 text-[#B80F15] border-gray-300 focus:ring-[#B80F15] ${isReadOnly ? 'cursor-not-allowed ' : ''}`}
          />
          <span className="text-sm text-[#4F4F4F]">Campi della categoria</span>
        </label>
        <label className={`flex items-center gap-2 ${isReadOnly ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}>
          <input
            type="radio"
            value="campi_corso"
            {...register('discente')}
            disabled={isReadOnly}
            className={`w-4 h-4 text-[#B80F15] border-gray-300 focus:ring-[#B80F15] ${isReadOnly ? 'cursor-not-allowed opacity-50' : ''}`}
          />
          <span className="text-sm text-[#4F4F4F]">Definisci campi dedicati a questo corso</span>
        </label>
      </div>
      <div className="w-full ">
        {items.map((item, idx) => {
          const checked = !!selections?.[item.id];
          return (
            <div key={item.id} className={`flex items-center justify-between px-0 py-1.5 ${idx !== items.length - 1 ? 'border-b border-gray-200' : ''}`}>
              <div className="flex items-center gap-12">
                <span className="text-sm text-black min-w-[180px]">{item.name}</span>
                <span className="text-sm text-[#6B7280]">{item.role}</span>
              </div>
              <div className="flex items-center gap-2">
                <EdSwitch
                  id={`attore-${item.id}`}
                  value={checked}
                  onChange={() => setValue(`discentiSelezionati.${item.id}`, !checked, { shouldDirty: true })}
                  disabled={isReadOnly}
                />
                <span className={`text-sm ${checked ? 'text-black' : 'text-gray-400'}`}>Selezionato</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Form per aggiungere nuovo campo - visibile solo se è selezionato il secondo radio e non in read-only */}
      {selected === 'campi_corso' && !isReadOnly && (
        <div className="flex items-center w-full justify-between gap-4">
          <div className="flex items-center gap-4 w-full">
            {/* Dropdown Tipologia campo */}
            <div className="flex-1 w-1/3">
              <EdSelect
                label="Tipologia campo*"
                id="tipologia"
                options={tipologiaOptions}
                value={tipologia}
                placeholder="Seleziona tipologia"
                onChange={handleTipologiaChange}
              />
            </div>

            {/* Input Nome etichetta */}
            <div className="flex-1 w-1/3 pt-[4px]">
              <EdTextfield
                label="Nome etichetta*"
                type="text"
                id="nomeEtichetta"
                placeholder="Inserisci nome etichetta"
                register={{
                  onChange: handleNomeEtichettaChange,
                  value: nomeEtichetta
                }}
              />
            </div>

            {/* Input Descrizione */}
            <div className="flex-1 w-1/3 pt-[4px]">
              <EdTextfield
                label="Descrizione"
                type="text"
                id="descrizione"
                placeholder="Inserisci descrizione"
                register={{
                  onChange: handleDescrizioneChange,
                  value: descrizione
                }}
              />
            </div>
          </div>

          {/* Pulsanti */}
          <div className="flex gap-2 items-center">
            <button
              onClick={handleConferma}
              disabled={!tipologia || !nomeEtichetta}
              className="px-4 py-2 bg-red-700 text-white text-sm font-medium rounded hover:bg-red-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
            >
              CONFERMA
            </button>
            <button
              onClick={handleAnnulla}
              className="px-4 py-2 bg-blue-100 text-blue-700 text-sm font-medium rounded hover:bg-blue-200 disabled:bg-gray-200 disabled:cursor-not-allowed transition-colors"
            >
              ANNULLA
            </button>
          </div>
        </div>
      )}

      {/* Sezione voci del menu a tendina - ramificazione dalla riga principale */}
      {selected === 'campi_corso' && tipologia === 'menu' && !isReadOnly && (
        <div className="ml-4 border-l-2 border-gray-300 pl-4 mt-2">
          <div className="flex flex-col gap-3">
            {/* Lista dei textfield per le voci del menu */}
            {vociTendina.map((voce, index) => (
              <div key={index} className="flex items-center gap-3">
                {/* Linea orizzontale che collega al textfield */}
                <div className="w-4 h-0.5 bg-gray-300 relative -ml-4">
                  {/* Punto di connessione */}
                  <div className="absolute -left-2 -top-1 w-1 h-1 bg-gray-300 rounded-full"></div>
                </div>
                <div className="w-[250px]">
                  <EdTextfield
                    label={index === 0 ? "Voce menu a tendina*" : ""}
                    type="text"
                    id={`voce-${index}`}
                    placeholder="Inserisci voce menu"
                    register={{
                      onChange: (e: any) => handleVoceChange(index, e.target.value),
                      value: voce
                    }}
                  />
                </div>
                {(
                  <button
                    onClick={() => handleRimuoviVoce(index)}
                    className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded transition-colors"
                  >
                    <i className="ri-delete-bin-line text-lg"></i>
                  </button>
                )}
              </div>
            ))}

            {/* CTA per aggiungere nuova voce */}
            {(
              <button
                onClick={handleAggiungiVoce}
                className="text-red-600 hover:text-red-800 text-sm font-medium self-start transition-colors"
              >
                + Aggiungi nuova voce
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default MixedDiscentiSection